// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Z06M","error":"Textarea_error__2uchc","readonly":"Textarea_readonly__3Tbj5","disabled":"Textarea_disabled__3OHwU"};